import styled from '@emotion/styled'
import { breakpoint } from '../../../../__styling'
import { WardenButton } from '../../../warden'

export const VerifyEmailButton = styled(WardenButton)({
    [breakpoint('sm')]: {
        alignSelf: 'center',
    },
})
